import { Stack, Typography } from "@mui/material";

export const ContractAdditionalAgreement = ({ contractSettings }) => {
  if (contractSettings?.showContractAdditionalAgreement)
    return (
      <Stack>
        <Typography
          sx={{
            fontSize: "12px",
            fontWeight: 550,
          }}
        >
          {contractSettings?.contractAdditionalAgreement}
        </Typography>
      </Stack>
    );
};
